import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-height: calc(100% - 128px);
`;

export const Content = styled.div`
    flex: 1 0 auto;
`;

export const Footer = styled.div`
    flex-shrink: 0;
    margin-bottom: 6px;
`;

export const ProfileInfoContainer = styled.div`
    padding: 12px;
`;

export const ProfileMenuButton = styled(IconButton)`
    margin: 0 !important;
    padding: 0 !important;
    float: right;
`;

export const StyledDivider = styled(Divider)`
    margin: 0;
`;
